<template>
  <path
    d="M17.46 41.5598H36.74"
    :stroke="iconBorder"
    stroke-width="5"
    fill="transparent"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M17.46 31.9199H36.74"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M36.74 7.82007H48.79C49.4292 7.82007 50.0422 8.07398 50.4941 8.52594C50.9461 8.9779 51.2 9.5909 51.2 10.2301V60.8401C51.2 61.4792 50.9461 62.0922 50.4941 62.5442C50.0422 62.9962 49.4292 63.2501 48.79 63.2501H5.41C4.77083 63.2501 4.15784 62.9962 3.70587 62.5442C3.25391 62.0922 3 61.4792 3 60.8401V10.2301C3 9.5909 3.25391 8.9779 3.70587 8.52594C4.15784 8.07398 4.77083 7.82007 5.41 7.82007H17.46"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M15.05 17.46V15.05C15.05 11.8541 16.3195 8.78918 18.5794 6.52936C20.8392 4.26955 23.9041 3 27.1 3C30.2959 3 33.3608 4.26955 35.6206 6.52936C37.8805 8.78918 39.15 11.8541 39.15 15.05V17.46H15.05Z"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      required: false,
      default: "black",
    },
    iconBorder: {
      type: String,
      required: false,
      default: "black",
    },
  },
};
</script>

<style scoped>
  path {
    font-family: var(--iconFontFamily);
    font-size: var(--iconFontSize);
    stroke:var(--iconColor)
  }
  .group:hover .group-hover\:text-hoverIcon  path {
    stroke:var(--iconHoberColor)
  }
</style>